module.exports = __webpack_public_path__ + "assets/img/free_4.03a1f328.png";